import { SharePointListClient, type ListItem } from '../SharePointListClient';

/**
 * `99.ABM_CategoriasSubCategorias` — the 3-level taxonomy that drives
 * Tesorería's Ingreso/Egreso dialogs (Categoria → CuentaContable →
 * Descripción). One row per unique `(Categoria_CSC, CuentaContable_CSC,
 * Descripcion_CSC)` triplet.
 *
 * `Compras_CSC = 'SI'` marks rows that surface in Tesorería's manual-
 * ingreso/egreso dialogs — PowerApps filters by this flag before
 * building the cascading combobox. Rows without the flag are used by
 * other screens (e.g. quick labels for admin notes).
 */
export type CategoriasSubCategoriasFields = {
  Title?: string | null;
  Categoria_CSC?: string | null;
  CuentaContable_CSC?: string | null;
  Descripcion_CSC?: string | null;
  Compras_CSC?: 'SI' | 'NO' | string | null;
  Status_CSC?: 'Activo' | 'Inactivo' | string | null;
};

export type CategoriasSubCategoriasItem = ListItem<CategoriasSubCategoriasFields>;

export const categoriasSubCategoriasClient =
  new SharePointListClient<CategoriasSubCategoriasFields>('ABM_CategoriasSubCategorias');

/**
 * Fetch the Tesorería taxonomy (rows flagged for Ingreso/Egreso use).
 * Defensive pattern: try the indexed filter first, fall back to a
 * client-side filter if `Compras_CSC` isn't indexed on the tenant.
 */
export async function listTesoreriaCategorias(): Promise<CategoriasSubCategoriasItem[]> {
  try {
    return await categoriasSubCategoriasClient.listItems({
      filter: "fields/Compras_CSC eq 'SI'",
      top: 5000,
    });
  } catch {
    const all = await categoriasSubCategoriasClient.listItems({ top: 5000 });
    return all.filter((r) => r.fields.Compras_CSC === 'SI');
  }
}
